module.exports = __webpack_public_path__ + "static/media/buxton-16.fcf6caa5.jpg";